// Resolves the bot backend origin for a given shop, mirroring the routing already in chatfooter.js.
export function getBotServerOrigin(shopId) {
  if (shopId === "null") {
    return "http://127.0.0.1:8080";
  }
  if (shopId === "Krunk.ai") {
    return "https://krunk-demo.agreeableplant-c6fa5f15.centralindia.azurecontainerapps.io";
  }
  if (shopId === "headsupfortails.myshopify.com") {
    return "https://modular-bot-371280248581.asia-south1.run.app";
  }
  return "https://modular-bot-371280248581.asia-south1.run.app";
}

// Warms DNS/TCP/TLS for an origin ahead of the first request to it, if not already warmed.
export function preconnectTo(origin) {
  if (!origin || typeof document === "undefined") return;
  const existing = document.head.querySelector(`link[rel="preconnect"][href="${origin}"]`);
  if (existing) return;

  const link = document.createElement("link");
  link.rel = "preconnect";
  link.href = origin;
  link.crossOrigin = "anonymous";
  document.head.appendChild(link);
}

// Reads the browser's recorded DNS/TCP/TLS/TTFB breakdown for a completed request, if available.
// dns_ms/tcp_ms/tls_ms read as 0 unless the target server sends a Timing-Allow-Origin header,
// since browsers zero out restricted cross-origin timing fields by default.
export function getResourceTiming(url) {
  if (typeof performance === "undefined" || !performance.getEntriesByName) return null;

  const entries = performance.getEntriesByName(url, "resource");
  const entry = entries[entries.length - 1];
  if (!entry) return null;

  return {
    dns_ms: Math.round(entry.domainLookupEnd - entry.domainLookupStart),
    tcp_ms: Math.round(entry.connectEnd - entry.connectStart),
    tls_ms: entry.secureConnectionStart > 0 ? Math.round(entry.connectEnd - entry.secureConnectionStart) : 0,
    ttfb_ms: Math.round(entry.responseStart - entry.requestStart),
    download_ms: Math.round(entry.responseEnd - entry.responseStart),
    total_ms: Math.round(entry.responseEnd - entry.startTime),
  };
}
